<template>
<div id="mainHeader">
<div class="homepage-for-desktop" v-for="item in items" :key="item.id">
<div class="row pb-3 border-bottom" >
    <div class="col-md-2 align-self-center">
        <img v-bind:src="item[0].JSon0[0].LogoURL"  class="img-fluid top-img rounded" alt="Responsive image">
    </div>
    <div class="col-md-6 pl-0">
        <span class="main-heading mb-0 align-middle">{{item[0].JSon0[0].CompanyName}}</span>
        <span class="align-middle"><img src="../assets/img/newchanges/Icon_awesome-check-circle.svg" class="img-fluid rounded ml-2" alt="Responsive image"></span>
        <p  class="khichdi-address mb-0">{{item[0].JSon0[0].SpecialityStatement}}</p>
        <span v-if="!easyCommerce" class="khichdi-address mb-0">{{item[0].JSon0[0].Address}}</span>
        <span v-if="easyCommerce" class="khichdi-address mb-0">{{item[0].JSon0[0].Address}}</span>

        <span v-if="selectBranchBoolean" data-toggle="modal" data-target="#currentLocation" @click="selectBranch()" class="option-font-size cCursorhover custom-text-color outlet-change ml-2">Change Outlet <i class="fas fa-chevron-down"></i></span>

        <div class="row" v-if="!easyCommerce">
            <div class="col-md-6">
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text bg-white custom-text-color border-0 p-0 pr-1"><i class="far fa-clock"></i></span>
                    </div>
                   <p class="khichdi-address mb-0">{{item[0].JSon0[0].WorkHoursStatement}}</p>
                </div>
            </div>
            <div class="col-md-6" >
                <span v-if="item[0].JSon0[0].AveragePreparationTime != ''" class="khichdi-address mr-3 cPreparationicon"><i class="fas fa-bell mr-2"></i>{{item[0].JSon0[0].AveragePreparationTime}} Min</span>
                <span v-if="item[0].JSon0[0].PriceStatement != ''" class="khichdi-address"><i class="fas fa-credit-card custom-text-color mr-2"></i>{{item[0].JSon0[0].PriceStatement}} for 2</span>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 mt-3" >
                <!-- <a v-if="item[0].JSon2.length != 0" @click="call(item[0].JSon2[0].MobileNumber)" class="contact-details text-dark font-weight-normal mr-3 cCursorhover"><img src="../assets/img/newchanges/Vector.svg" class="img-fluid rounded mr-2" alt="Responsive image">{{item[0].JSon2[0].MobileNumber}}</a> -->
                <a @click="openWhatsapp(item[0].JSon2[0].MobileNumber)" class="contact-details text-dark font-weight-normal cCursorhover"><span class="align-middle"><i class="fab fa-whatsapp whatsapp-icon text-success font-weight-bold mr-3"></i></span><span class="align-middle">Send Message</span></a>
                <a  class="contact-details text-dark mr-2 pl-1"><span class="beauty-rating text-white  pl-2 pt-1 pb-1 pr-2"><i class="fas fa-star"></i> {{item[0].JSon0[0].AverageRating}}</span> {{item[0].JSon9.length}} reviews</a>
                <a  class="ask-question text-white mr-2 pl-1"><img src="../assets/img/beauty/Vector (4).svg" class="img-fluid rounded check-img ml-2 mr-2" alt="Responsive image">Ask A Question</a>
            </div>
        </div>
    </div>

    <div class="col-md-4 align-self-center">
        <div  class="row">
            <div  class="col-md-12 custom-text-color" v-if="item[0].JSon3.length != 0">
                <a  class=" font-weight-bold"><span ><i  class="fas fa-tags mr-2"></i></span><span >OFFERS</span></a>
                <!-- eslint-disable -->
                <p v-for="offer,index in item[0].JSon3" :key="offer.id" v-if="index < 2" class="khichdi-address mb-0">{{offer.Header}}</p>
                <!-- eslint-enable -->
                <a  class="mt-1 cMoreoffer cCursorhover" @click="moreOffers()">more offers</a>
                </div>
            </div>
            <div class="row pl-3 pr-3" v-if="item[0].JSon0[0].AcceptInstantAppointments == 'Y'">
                <div v-if="!serviceBooked"  class="col-md-12 consultation bg-success pt-1 pb-1 mt-2 text-center cCursorhover" @click="geolocate()" >
                    <a id="bookInstant" class="text-white mr-2"><b class="align-middle"><i  class="fas fa-bolt book-consultation text-success mr-3 text-center"></i></b><span class="align-middle">Book Instant Appointment </span></a>
                </div>
                <div v-if="serviceBooked" class="col-md-12 consultation bg-error pt-1 pb-1 mt-2 text-center cCursorhover" data-toggle="modal" data-target="#CancelBooking">
                    <a class="text-white mr-2"><b class="align-middle"><i  class="fas fa-bolt book-consultation text-success mr-3 text-center"></i></b><span class="align-middle">Your estimated wait time is 12 mins </span></a>
                </div>
            </div>
        </div>
    </div>

<div class="row mt-2 pb-2 border-bottom">
                    <div class="col-md-8">
                        <div class="row">
                            <div class="card border-0"  v-for="portfolio,index in item[0].JSon8" :key="portfolio.id">
                                <img class="card-img all-makeup-img" v-bind:src="portfolio.MediaURL" alt="Card image">
                                <div v-if="index == (item[0].JSon8.length-1)" @click="moveToGallery()" class="card-img-overlay last-img text-center cCursorhover">
                                    <a>View Portfolio</a>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                    <div class="col-md-4 amentities-font" v-if="item[0].JSon6.length != 0 && !roomBoolean" >
                        <p class="amentities mb-0">AMENTITIES</p>
                        <div class="row mt-2" >
                            <div class="col" v-for="amenities in item[0].JSon6" :key="amenities.id">
                                <a>
                                    <img width="20px" height="20px" class="img-fluid" v-bind:src="amenities.ImageURL">
                                    <p class="mb-0">{{amenities.Amenity}}</p>
                                </a>
                            </div>
                            
                        </div>
                    </div>
                </div>

    <div class="row text-center home-tabs font-weight-bold mt-1 mb-1">
        <div class="col cCursorhover" @click="selectListingType('Services')">
            <a id="Services" class="cModalactive" >Service & Bookings</a>
        </div>
        <!-- eslint-disable -->
        <div class="col cCursorhover" v-for="services in category" :key="services.id" v-if="services[0].JSon10 != undefined && services[0].JSon10.length != 0" @click="selectListingType('Packages')">
            <!-- eslint-enable -->
            <a id="Packages" class="a" >Packages & More</a>
        </div>
        <div v-if="item[0].JSon0[0].HasOnlineStore == 'Y'" class="col cCursorhover" @click="selectListingType('Store')">
            <a id="Store">Store</a>
        </div>
        <div class="col cCursorhover" @click="selectListingType('Rooms')">
            <a id="Rooms">Rooms</a>
        </div>
        <div class="col cCursorhover" @click="moveToReview()">
            <a id="Review">Review & Ratings</a>
        </div>
    </div>
</div>

<div class="index-for-mobile" v-for="item in items" :key="item.id">
        <div class="row pb-1 border-bottom" >
    <div class="col-md-2 col-3 align-self-center pr-0">
        <img v-bind:src="item[0].JSon0[0].LogoURL"  class="rounded"  height="80px" width="80px" alt="Responsive image">
    </div>
    <div class="col-md-6 col-9 align-self-center pb-1">
        <span class="main-heading mb-0 align-middle">{{item[0].JSon0[0].CompanyName}}</span>
        <span class="align-middle"><img src="../assets/img/newchanges/Icon_awesome-check-circle.svg" class="img-fluid rounded ml-2" height="12px" width="12px" alt="Responsive image"></span>
        <p class="khichdi-address mb-0">{{item[0].JSon0[0].SpecialityStatement}}</p>
        <span class="khichdi-address mb-0">{{item[0].JSon0[0].Address}}</span>
         
         <span v-if="selectBranchBoolean" data-toggle="modal" data-target="#currentLocation" @click="selectBranch()" class="option-font-size cCursorhover custom-text-color outlet-change ml-2">Change Outlet <i class="fas fa-chevron-down"></i></span>

        <div class="row" v-if="!easyCommerce">
            <div class="col-md-12">
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text bg-white custom-text-color border-0 p-0 pr-1"><i class="far fa-clock"></i></span>
                    </div>
                    <p class="khichdi-address mb-0">{{item[0].JSon0[0].WorkHoursStatement}}</p>
                </div>
            </div>
        </div> 
    </div>
    <div class="col-md-12 border-top" v-if="!easyCommerce">
        <div class="row">
            <div class="col-4">

                <span v-if="item[0].JSon0[0].AveragePreparationTime != ''" class="khichdi-address mr-3 cPreparationicon"><i class="fas fa-bell mr-2"></i>{{item[0].JSon0[0].AveragePreparationTime}} Min</span>
            </div>
            <div class="col-4">
                <span v-if="item[0].JSon0[0].PriceStatement != ''" class="khichdi-address"><i class="fas fa-credit-card custom-text-color mr-2"></i><b>{{item[0].JSon0[0].PriceStatement}} for 2</b></span>
            </div>
            <div class="col-4">
                <!-- <span class="khichdi-address"><i class="fas fa-info-circle custom-text-color mr-2"></i><b>More info</b></span> -->
            </div>
        </div>
    </div>
</div>
<!-- <div class="row mt-2 pb-2 border-bottom" v-if="item[0].JSon3.length != 0">
    <div class="col-6 pr-1" v-for="offer in item[0].JSon3" :key="offer.id" >
        <a class="btn bg-warning text-white btn-block pt-0 pb-0">
            <span class="extra-offer">{{offer.header}}</span>
            <p class="member-offer mb-0">{{offer.Description}}</p>
        </a>
    </div>
</div> -->

<div class="row mt-1 custom-container-others">
    <div class="col beauty-info">
        <a class="text-dark mr-2"><span class="align-middle custom-text-color"><i class="fa fa-2x fas fa-star mr-2"></i></span><span class="align-middle review">19 reviews</span></a>
    </div>
    <div class="col beauty-info">
        <a class="text-dark mr-2"><span class="align-middle custom-text-color"><i class="fa fa-2x fas fa-star mr-2"></i></span><span class="align-middle review">Ask A Question</span></a>
    </div>

    <div class="row pb-2 pt-2 mt-2 border-bottom border-top pl-4 pr-4">
        <div class="col-md-8">
            <div class="row"  v-for="item in items" :key="item.id">
                <div class="card border-0" v-for="portfolio,index in item[0].JSon8" :key="portfolio.id">
                    <img class="card-img all-makeup-img" v-bind:src="portfolio.MediaURL" alt="Card image">
                    <div v-if="index == (item[0].JSon8.length-1)" @click="moveToGallery()" class="card-img-overlay last-img text-center cCursorhover">
                                    <a>View Portfolio</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="row mt-2 pb-2 border-bottom pr-3">
    <div class="col-md-12 scrollmenu offer-menu">
    <!-- eslint-disable -->
        <a class="btn bg-warning text-white pt-0 pb-0 cOfferbtn" v-for="offer in item[0].JSon3" :key="offer.id" v-if="offer.Context == 'OFFER'">
    <!-- eslint-enable -->
            <span class="extra-offer">{{offer.Header}}</span>
            <p class="member-offer mb-0">{{offer.Description}}</p>
        </a>
    </div>
</div>

<div class="row pl-4 pr-4" v-if="item[0].JSon0[0].AcceptInstantAppointments == 'Y'">
    <div class="col-12 consultation bg-success pt-2 pb-2 mt-2 text-center cCursorhover"  @click="geolocate()">
        <a id="bookInstant" class="text-white mr-2"><b class="align-middle"><i class="fas fa-bolt book-consultation text-success mr-3 text-center"></i></b><span class="align-middle">Book Instant Appointment </span></a>
    </div>
</div>
<!-- eslint-disable -->
<div class="row custom-container-others" v-if="item[0].JSon6.length != 0">
    <!-- eslint-enable -->
    <div class="col-md-12 amentities-font">
        <hr class="mt-0" />
        <p class="amentities mb-0">AMENTITIES</p>
        <div class="row mt-2" >
            <div class="col" v-for="amenities in item[0].JSon6" :key="amenities.id">
                <a>
                    <img width="20px" height="20px" class="img-fluid" v-bind:src="amenities.ImageURL">
                    <p class="mb-0">{{amenities.Amenity}}</p>
                </a>
            </div>
        </div>
        <hr class="mb-0" />
    </div>
</div>


<div class="row slider-margin mt-2 justify-content-center order-type">
    <div class="col p-1">
        <button v-if="item[0].JSon0[0].HomeDelivery == 'Y'" class="btn order-type custom-text-color btn-block right-btn border-0 default orderType" id="home" @click="selectDeliveryType('home')">{{item[0].JSon0[0].LblDelivery}}</button>
    </div>
    <div class="col p-1">
        <button v-if="item[0].JSon0[0].Pickup == 'Y'" class="btn order-type custom-text-color btn-block right-btn border-0" id="takeAway" @click="selectDeliveryType('takeAway')">{{item[0].JSon0[0].LblPickup}}</button>
    </div>
    <div class="col p-1">
        <button v-if="item[0].JSon0[0].InStorePurchase == 'Y'" class="btn order-type custom-text-color btn-block right-btn border-0" id="dineIn" @click="selectDeliveryType('dineIn')">{{item[0].JSon0[0].LblInStore}}</button>
    </div>
</div>


<div class="row mt-2 set-deliver ml-1 pt-1 pb-1 mr-1 d-flex" v-if="showDeliveryTime && item[0].JSon0[0].ScheduledDelivery == 'Y'" data-toggle="modal" data-target="#DeliveryTime">
    <div class="col-lg-2 col-md-2 col-2 custom-text-color text-center align-self-center">
        <i class="far fa-clock align-middle"></i>
    </div>
    <div class="col-lg-8 col-md-8 col-8 delivery-time align-self-center p-0">
        <p class="mb-0 align-middle">{{deliveryStatement}}</p>
        <span>{{deliveryDate}}, {{deliveryTime}}</span>
    </div>
    <div class="col-lg-2 col-md-2 col-2 custom-text-color text-center align-self-center ">
        <i class="fas fa-angle-right"></i>
    </div>
</div>

</div>

<div class="modal bottom fade show" id="currentLocation" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true">
    <div class="modal-dialog fixed-bottom m-0 mw-100" role="document">
        <div class="modal-content select-address border-0">
            <div class="modal-header pt-0">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span data-dismiss="modal" aria-hidden="true"><img src="../assets/img/Icon material-cancel.svg" class="img-fluid"></span>
                </button>
            </div>
            <div class="modal-body pt-0">
                <div class="row">
                    
                    <div class="col-md-12 mt-2 mb-2">
                        <span><b class="custom-text-color">All Outlets</b></span>
                    </div>
                    <div class="col-md-12 address-font cCursorhover" v-for="branches,index in storeList" :key="index.id" @click="onSelect(branches)" data-dismiss="modal">
                        <b>{{branches.BranchName}}</b>
                        <p class="mb-0">{{branches.Locality}}, {{branches.City}}</p>
                        <span v-if="index < 2"><img src="../assets/img/location/Vector.svg" class="img-fluid mr-2 align-middle"></span><span v-if="index <= 2" class="text-muted">0.2 kms</span>
                        <span v-if="index > 2"><img src="../assets/img/location/Vector.svg" class="img-fluid mr-2 align-middle"></span><span v-if="index > 2" class="text-muted">0.8 kms</span>
                        
                        
                        <hr/>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="InstantBookModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true">
    <div class="modal-dialog modal-md modal-dialog-centered" role="document">
        <div class="modal-content select-address border-0">
            <div class="modal-header pl-4">
                <h5 class="modal-title">BOOK INSTANT APPOINTMENT</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span data-dismiss="modal" aria-hidden="true"><img src="../assets/img/Icon material-cancel.svg" class="img-fluid"></span>
                </button>
            </div>
            <div class="modal-body instantapp-model pr-4 pl-4 pb-4">
                <div class="cInstantModel" v-for="services in category" :key="services.id">
            <!-- eslint-disable -->
            <div class="form-check cOptionbar mb-3" v-for="instantService in services[0].JSon1" :key="instantService.id" v-if="instantService.AllowInstantAppointment == 'Y'">
                <!-- eslint-enable -->
                <input class="form-check-input cInstantform" type="radio" name="exampleRadios" id="exampleRadios1"
                    value="option1" checked>
                <label class="form-check-label" for="exampleRadios1">
                    {{instantService.CompanyService}}
                </label>
                <div class="cServiceduration">
                    <span>Rs {{instantService.OfferPrice}}</span>
                    <span>-</span>
                    <span>{{instantService.StandardServiceDuration}} Mins</span>
                </div>
            </div>

            
            <div class="card-footer border-0 bg-white footer-shadow mt-3 row add-cart" data-dismiss="modal" data-toggle="modal" data-target="#BookingSuccess">
                    <div class="col-md-12" @click="InstantServiceBook()">
                        <a  class="btn btn-block text-white custom-bg"><i class="fas fa-shopping-bag mr-2"></i>BOOK NOW</a>
                    </div>
                </div>

        </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="BookingSuccess" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true">
    <div class="modal-dialog modal-md modal-dialog-centered" role="document">
        <div class="modal-content select-address border-0">
            <div class="modal-header pl-4">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span data-dismiss="modal" aria-hidden="true"><img src="../assets/img/Icon material-cancel.svg" class="img-fluid"></span>
                </button>
            </div>
            <div class="modal-body instantapp-model pr-4 pl-4 pb-4">
                <div class="cInstantmessage text-center">
                        <div class="cInstantImg mb-3">
                        <img src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti/webstore/accepted.png" alt="">
                </div>
                <div class="cInstanttxtone" v-for="item in items" :key="item.id">
                     <p>Your instant appointment request has been sent to {{item[0].JSon0[0].CompanyName}}.</p>
                </div>
                <div class="cInstantwaittime">
                    <p>Estimated wait time is 12 minutes.</p>
                </div>
                <div class="cInstanttexttwo">
                   <p>You'll be get notified soon.</p>
                 </div>
        </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="CancelBooking" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true">
    <div class="modal-dialog modal-md modal-dialog-centered" role="document">
        <div class="modal-content select-address border-0">
            <div class="modal-header pl-4">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span data-dismiss="modal" aria-hidden="true"><img src="../assets/img/Icon material-cancel.svg" class="img-fluid"></span>
                </button>
            </div>
            <div class="modal-body instantapp-model pr-4 pl-4 pb-4">
                <div class="cInstantmessage text-center">
                    <div class="cInstantImg mb-3">
                        <img src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti/webstore/duration.png" alt="">
                    </div>
                    <div class="cInstanttxtone" v-for="item in items" :key="item.id">
                        <p>Your instant appointment request has been sent to {{item[0].JSon0[0].CompanyName}}.</p>
                    </div>
                    <div class="cInstantwaittime">
                        <p>Estimated wait time is 12 minutes.</p>
                    </div>
                    <div class="cInstantbtn mb-2">
                        <a class="btn btn-primary btn-instant" data-dismiss="modal" role="button">Cancel Appointment</a>
                    </div>
                    <div class="cInstanttexttwo">
                        <p>You'll be get notified soon.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade login show" id="DeliveryTime" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header pl-4">
                <h5 class="modal-title" id="exampleModalLabel">Schedule Delivery</h5>
                <button type="button" class="close" id="closeDelivery" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true"><img src="../assets/img/Icon material-cancel.svg" class="img-fluid"></span>
                </button>
            </div>

            <div class="modal-body">
                <div class="col-md-12">
                    <div class="row">
                        <div class="col-12 mb-2">
                            <button type="button" data-dismiss="modal" class="btn btn-block cModalbtnenable">Process Immediately</button>
                        </div>
                        <div class="col-12" data-toggle="modal" data-target="#scheduleForLater" @click="ScheduleDelivery()">
                            <button type="button" class="btn btn-block cModalbtndisable">Schedule For Later</button>
                        </div>
                    </div>
                </div>

                <div class="col-md-12 text-center mt-4">
                    <p>Your order will be processed ASAP (As soon as possible).</p>
                    <img src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti/images/schedule.png" alt="">
                </div>
            </div>

        </div>
    </div>
</div>

<div class="modal fade login show" id="scheduleForLater" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header pl-4">
                <h5 class="modal-title" id="exampleModalLabel">{{deliveryStatement}}</h5>
                <button type="button" class="close" id="closeScheduleLater" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true"><img src="../assets/img/Icon material-cancel.svg" class="img-fluid"></span>
                </button>
            </div>


            <div class="modal-body">
                <div class="col-md-12">
                    <div class="row">
                        <div class="col-12 mb-2">
                            
                        <button @click="BackToImmediate()" data-toggle="modal" data-target="#DeliveryTime" type="button" class="btn btn-block cModalbtndisable">Process Immediately</button>
                        </div>
                        <div class="col-12">
                            <button type="button" class="btn btn-block cModalbtnenable">Schedule For Later</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal-body pr-4 pl-4 pb-4">
                <div class="col-md-12">
                    <form>
                        <div class="row">
                            <div class="col-6">
                                <div class="form-group">
                                    <label class="col-form-label"><small><b>Select Delivery Date</b></small></label>
                                    <div class="input-group-prepend custom-text-color">
                                        <div
                                            class="input-group-text date-time-background border-radius-date prepend-padding-right border-right-0">
                                            <i class="far fa-calendar-alt"></i></div>
                                        <input type="date" v-on:change="Datepicker($event)" v-bind:min="today"
                                            class="form-control date-time-background border-radius-text border-left-0"
                                            name="datepicker" value="" />

                                    </div>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="form-group">
                                    <label class="col-form-label"><small><b>Select Delivery time</b></small></label>
                                    <div class="input-group-prepend custom-text-color">
                                        <div
                                            class="input-group-text date-time-background border-radius-date border-right-0">
                                            <i class="far fa-clock"></i></div>
                                        <input type="time" v-on:change="Timepicker($event)"
                                            class="form-control date-time-background border-radius-text border-left-0"
                                            name="timepicker" value="09:00" />
                                        <div class="input-group-append">
                                            <span
                                                class="input-group-text date-time-background border-radius-forword border-left-0"><i
                                                    class="fas fa-chevron-right"></i></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            <div class="col-md-12">

                <button data-dismiss="modal" type="button" @click="confirmDeliveryTime()" class="btn btn-block pay-btn mb-4">Confirm Delivery Time</button>
            </div>

        </div>
    </div>
</div>

</div>
</template>

<script>

export default {
  
  name: 'HelloWorld',
  props: {
    msg: String
  },
  data : function(){
      return {
          storeDetails : [],
          storeList : [],
        //   componentKey : 0,
          selectBranchBoolean : true,
          deliveryTypeList : ['home','takeAway','dineIn'],
          ListingTypeList : ['Services','Packages','Store','Review',"Rooms"],
          easyCommerce : true,
          tempDeliveryDate : 'Today',
          tempdeliveryTime : 'ASAP',
          deliveryDate : 'Today',
          deliveryTime : 'ASAP',
          showDeliveryTime : true,
          deliveryStatement : 'SET DELIVERY TIME',
          today : '',
          serviceBooked : false,
          marker: { position: { lat: 10, lng: 10 } },
          roomBoolean : false
      }
  },
    computed:{
      items() {
        return this.$store.state.items
      },
      category() {
        return this.$store.state.category
      }
    },
    mounted(){
      sessionStorage.setItem('DeliveryType','home')
        this.today = new Date().toISOString().split('T')[0]
      
      this.$root.$on('boolean',(value) =>{
            console.log(value)
                this.selectBranchBoolean = value
            })
      if(sessionStorage.getItem('ECommDS') == 'EASYCOMM1'){
            this.easyCommerce = true
        }
        else if(sessionStorage.getItem('ECommDS') == 'ECOMM2' || sessionStorage.getItem('ECommDS') == 'ecomm2'){
            this.easyCommerce = false
        }
    },
    methods: {
        openWhatsapp: function(number){
            window.open('//api.whatsapp.com/send?phone='+number)
        },
        call: function(number){
            window.open('tel:' + number)
        },
        goToGallery: function(){
             this.$router.push({path:this.$route.params.handle+'/gallery'})
        },
        selectBranch: function(){
            this.storeList = JSON.parse(sessionStorage.getItem('StoreBranches'))
            console.log(this.storeList)
        },
         BackToImmediate: function(){
            var closeDeliveryComp = document.getElementById("closeScheduleLater")
            closeDeliveryComp.click()
        },
         geolocate() {
            navigator.geolocation.getCurrentPosition((position) => {
            this.marker.position = {
                lat: position.coords.latitude,
                lng: position.coords.longitude,
            }
            console.log(this.marker.position)
            this.getDistanceFromLatLonInKm(Number(sessionStorage.getItem("Latitude")),Number(sessionStorage.getItem("Longitude")),this.marker.position.lat,this.marker.position.lng)
            })
        },

        getDistanceFromLatLonInKm(lat1,lon1,lat2,lon2) {
            var R = 6371; // Radius of the earth in km
            var dLat = this.deg2rad(lat2-lat1);  // deg2rad below
            var dLon = this.deg2rad(lon2-lon1); 
            var a = 
                Math.sin(dLat/2) * Math.sin(dLat/2) +
                Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) * 
                Math.sin(dLon/2) * Math.sin(dLon/2)
                ; 
            var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
            var d = R * c; // Distance in km
            console.log(d)

            if((d*1000) < Number(sessionStorage.getItem("radius"))){
                 var openModel = document.getElementById('bookInstant')
                    openModel.setAttribute('data-toggle','modal')
                    openModel.setAttribute('data-target','#InstantBookModal')
                    openModel.click();
            }
            else{
                window.alert("Can't book instant appointment at this location.")
            }
        },

        deg2rad(deg) {
            return deg * (Math.PI/180)
        },

        InstantServiceBook: function(){
            this.serviceBooked = true
        },
        moveToGallery: function(){
            this.$router.push({name:'gallery'})
        },
        moveToReview: function(){
            this.$router.push({name:'ratings'})
        },
        selectListingType: function(type){
            this.$root.$emit(type)
            document.getElementById(type).classList.add('cModalactive')
            for(var i=0;i<this.ListingTypeList.length;i++){
                if(this.ListingTypeList[i] != type){
                    document.getElementById(this.ListingTypeList[i]).classList.remove('cModalactive')
                }
            }
            if(type == "Rooms"){
                this.roomBoolean = true
            }
            else{
                this.roomBoolean = false
            }
        },
        onSelect: function(branch){
          sessionStorage.setItem('handle',branch.BranchHandle);
          sessionStorage.setItem('ECommDS',branch.ECommDS);
          this.$router.go()
        //   this.componentKey +=1;
        },
         selectDeliveryType: function(deliveryType){
             if(deliveryType == 'dineIn'){
                this.showDeliveryTime = false;
            }
            else{
                this.showDeliveryTime = true;
            }

            if(deliveryType == 'takeAway'){
                this.deliveryStatement = 'SET TAKE-OUT TIME';
            }
            else{
                this.deliveryStatement = 'SET DELIVERY TIME';
            }

            document.getElementById(deliveryType).classList.add('orderType')
            sessionStorage.setItem('DeliveryType',deliveryType)
            for(var i=0;i<this.deliveryTypeList.length;i++){
                if(this.deliveryTypeList[i] != deliveryType){
                    document.getElementById(this.deliveryTypeList[i]).classList.remove('orderType')
                }
            }
        },
        moreOffers: function(){
             this.$router.push({name:'offers'})
        },
        Datepicker: function(event){
        console.log(event.target.value)
        this.tempDeliveryDate = event.target.value
        },
        Timepicker: function(event){
            this.tempdeliveryTime = event.target.value
        },
        confirmDeliveryTime: function(){
            this.deliveryDate = this.tempDeliveryDate;
            this.deliveryTime = this.tempdeliveryTime;

            sessionStorage.setItem('DeliveryDetails',JSON.stringify(({'deliveryDate':this.deliveryDate,'deliveryTime':this.deliveryTime})))
        },
        ScheduleDelivery: function(){
            var closeDeliveryComp = document.getElementById("closeDelivery")
            closeDeliveryComp.click()
        },
    }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
